import React from 'react';
import { SectionLayout } from 'components/Sections/SectionLayout';
import ContentfulContentBlock from 'components/Contentful/ContentfulContentBlock';
import ContentfulRowContent from 'components/Contentful/ContentfulRowContent';
import ContentfulRichText from 'components/RichText/ContentfulRichText';
import ContentfulInPageFeatures from 'components/Contentful/ContentfulInPageFeatures';
import ContentfulSection from 'components/Contentful/ContentfulSection';

const ToggleContent = ({ item }) => {
  const typeName = item?.__typename;

  if (typeName === 'ContentfulContentBlock') {
    return <ContentfulContentBlock {...item} />;
  } else if (typeName === 'ContentfulRowContent') {
    return <ContentfulRowContent {...item} />;
  } else if (typeName === 'ContentfulRichText') {
    return (
      <SectionLayout>
        <ContentfulRichText richText={item} />
      </SectionLayout>
    );
  } else if (typeName === 'ContentfulSection') {
    return <ContentfulSection {...item} spacing="None" />;
  } else if (typeName === 'ContentfulInPageFeatures') {
    return <ContentfulInPageFeatures {...item} toggleComponent />;
  } else {
    return item;
  }
};

export default ToggleContent;
